import { render, staticRenderFns } from "./flashsale.vue?vue&type=template&id=d4be9cae&scoped=true"
import script from "./flashsale.vue?vue&type=script&lang=ts"
export * from "./flashsale.vue?vue&type=script&lang=ts"
import style0 from "./flashsale.vue?vue&type=style&index=0&id=d4be9cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4be9cae",
  null
  
)

export default component.exports